'use client';

import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TypographyH2, TypographyMuted } from '../ui/typography';
import { useLanguageFromPath } from '@/hooks/useLanguageFromPath';
import { useRouter } from 'next/navigation';

export default function AboutContent() {
  const { t } = useTranslation();

  const router = useRouter();
  const lang = useLanguageFromPath();
  const [activeSection, setActiveSection] = useState('about-us');
  const prevLangRef = useRef(lang);

  useEffect(() => {
    // Detect language change and redirect to correct about page
    if (lang !== prevLangRef.current) {
      const aboutHref = lang === 'ru' ? '/ru/about' : '/about';
      router.push(aboutHref);
    }
    prevLangRef.current = lang;
  }, [lang, router]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'about-us';
      setActiveSection(hash);
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className='flex-1 my-8 mx-5 sm:mx-8'>
      {activeSection === 'about-us' && (
        <section id='about-us'>
          <div className='mb-6'>
            <TypographyH2>{t('aboutPage.aboutUs.title')}</TypographyH2>
            <TypographyMuted>{t('aboutPage.aboutUs.subtitle')}</TypographyMuted>
          </div>
          <div className='prose max-w-none'>
            <p>{t('aboutPage.aboutUs.content')}</p>
          </div>
        </section>
      )}

      {activeSection === 'getting-started' && (
        <section id='getting-started'>
          <div className='mb-6'>
            <TypographyH2>{t('aboutPage.gettingStarted.title')}</TypographyH2>
            <TypographyMuted>
              {t('aboutPage.gettingStarted.subtitle')}
            </TypographyMuted>
          </div>
          <div className='prose max-w-none'>
            <p>{t('aboutPage.gettingStarted.content')}</p>
          </div>
        </section>
      )}

      {activeSection === 'faq' && (
        <section id='faq'>
          <div className='mb-6'>
            <TypographyH2>{t('aboutPage.faq.title')}</TypographyH2>
            <TypographyMuted>{t('aboutPage.faq.subtitle')}</TypographyMuted>
          </div>
          <div className='prose max-w-none'>
            <p>{t('aboutPage.faq.content')}</p>
          </div>
        </section>
      )}
    </div>
  );
}
